/**
 * @file Builds the upload request handler an Ant Design upload component calls.
 */

import upload from "./upload";
import readFileContent from "./readFileContent";
import type { Request, UploadRequest, UploadResponse } from "./types";

/**
 * Builds the upload handler that reads the file, uploads it and reports the result.
 */
const getCustomUploadRequest = (request: Request, isPublic: boolean): UploadRequest => {
  /**
   * Reads the file, uploads its content and reports the result to the caller.
   */
  const uploadRequest: UploadRequest = async ({ file, onError, onSuccess }) => {
    const { type: contentType } = file;
    const content = await readFileContent(file);

    let response: UploadResponse;

    try {
      response = await upload(request, isPublic, contentType, content);

    } catch (error) {
      onError(error);

      return;
    }

    onSuccess(response);
  };

  return uploadRequest;
};

export default getCustomUploadRequest;
